function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0898 0 32 2.91015 32 6.5V25.5C32 29.0898 29.0898 32 25.5 32H6.5C2.91015 32 0 29.0898 0 25.5V6.5Z",
  fill: "#018AE6"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 2.625,
  fill: "white"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.406 3.99996C17.7291 3.99894 18.0109 4.21919 18.088 4.53296L18.765 7.28596C19.2828 7.45031 19.7848 7.66083 20.265 7.91496L22.405 6.63296C22.6815 6.46583 23.0364 6.50963 23.264 6.73896L25.252 8.72796C25.4813 8.95553 25.5251 9.31048 25.358 9.58696L24.076 11.723C24.3331 12.2066 24.5457 12.7127 24.711 13.235L27.464 13.912C27.7778 13.989 27.998 14.2709 27.997 14.594V17.406C27.998 17.7291 27.7778 18.0109 27.464 18.088L24.711 18.765C24.5517 19.2748 24.3472 19.7695 24.1 20.243L25.364 22.349C25.5311 22.6255 25.4873 22.9804 25.258 23.208L23.267 25.2C23.0394 25.4293 22.6845 25.4731 22.408 25.306L21.217 24.591L21.084 24.512C20.806 24.345 20.533 24.182 20.325 24.056C19.8267 24.3257 19.3041 24.5476 18.764 24.719L18.088 27.471C18.0109 27.7847 17.7291 28.005 17.406 28.004H14.594C14.2709 28.005 13.9891 27.7847 13.912 27.471L13.236 24.719C12.7088 24.5519 12.1981 24.337 11.71 24.077L10.864 24.584L10.776 24.637L10.39 24.868L10.31 24.916L9.659 25.3C9.38385 25.4686 9.02905 25.4273 8.8 25.2L6.811 23.208C6.58364 22.9789 6.54233 22.6241 6.711 22.349L7.933 20.3C7.67058 19.8082 7.454 19.2934 7.286 18.762L4.533 18.085C4.22032 18.0081 4.00037 17.7279 4 17.406V14.594C3.99898 14.2709 4.21923 13.989 4.533 13.912L7.286 13.233C7.43357 12.767 7.61885 12.3138 7.84 11.878L6.468 9.58696C6.30087 9.31048 6.34468 8.95553 6.574 8.72796L8.562 6.73896C8.79057 6.51168 9.14405 6.46806 9.421 6.63296L11.64 7.96496C12.1501 7.68707 12.6859 7.45934 13.24 7.28496C13.305 7.00796 13.4 6.60996 13.5 6.19996L13.526 6.09396C13.718 5.31196 13.909 4.53096 13.909 4.53096C13.9871 4.21689 14.2704 3.99733 14.594 3.99996H17.406ZM16 9.62492C12.4792 9.62492 9.62501 12.4791 9.62501 15.9999C9.62501 19.5207 12.4792 22.3749 16 22.3749C19.5208 22.3749 22.375 19.5207 22.375 15.9999C22.375 14.3092 21.7034 12.6877 20.5078 11.4921C19.3123 10.2966 17.6908 9.62492 16 9.62492Z",
  fill: "url(#paint0_linear_555:1393)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_555:1393",
  x1: 6.28285,
  y1: 3.99996,
  x2: 6.28285,
  y2: 23.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

function SvgIconMaintain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintain);
export default __webpack_public_path__ + "static/media/IconMaintain.1a1d8266.svg";
export { ForwardRef as ReactComponent };